import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type CrmOutboxEventCountsResult = QueryAtomResult<
  typeof crmOutboxEventCountsQueryAtom
>;

export const crmOutboxEventCountsQueryAtom = createQueryAtomFactory(
  'auditLog.crmOutboxEventCounts',
  () => ({
    crmOutboxEventCounts: {
      account: true,
      contact: true,
      accountAddress: true,
      customerInvitation: true,
    },
  }),
  {
    select: ({ crmOutboxEventCounts }) => crmOutboxEventCounts,
  },
);
